const SUPPORTED_LANGS = {
  arabic: "ar",
  english: "en",
} as const;

type Language = ValueOf<typeof SUPPORTED_LANGS>;

export { SUPPORTED_LANGS };
export type { Language };
